export default {
  namespaced: true,
  actions: {
    flash: ({ commit }, { message, type }) => {
      commit("setMessages", [[type, message]]);
    },
  },
  getters: {
    getMessages: state => state.messages,
  },
  mutations: {
    setMessages: (state, messages) => {
      state.messages = messages;
    },
  },
  state: {
    messages: [],
  },
};
